import React, { useState, useEffect } from "react";
import Volunteer from "../volunteer/Volunteer";
import { NavLink } from "react-router-dom";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { server } from "../../common";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function CsrInitiatives() {
  const [data, setData] = useState([]);

  console.log(data, "dfa8aaaghahg");

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    server
      .get("/csr/getallcsr", {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          const allData = response.data;

          if (allData.length > 0) {
            // last entry काढून सुरुवातीला टाका
            const last = allData[allData.length - 1];
            const remaining = allData.slice(0, -1);
            setData([last, ...remaining]);
          } else {
            setData(allData);
          }
        }
      })

      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };
  const parseImages = (imgData) => {
    try {
      return Array.isArray(imgData) ? imgData : JSON.parse(imgData || "[]");
    } catch (e) {
      console.error("Image parse error:", e);
      return [];
    }
  };

  return (
    <>
      <div>
        <img src="/images/in.jpg" className="img-fluid" alt="" />
        <div
          className="row justify-content-center  p-5"
          style={{ marginTop: "-80px" }}
        >
          <div className="col-md-9 bg-success text-white">
            <h4 className="p-4">
              Corporate Social Responsibility (CSR) Initiatives: Supporting
              Farmer Communities
              <hr className="w-25 custom-hr" size="2px" />
            </h4>
          </div>

          <div className="container my-4">
            <h3>Welcome to Our CSR Initiatives Page!</h3> <hr />
            <p>
              At Venkateshwara Farmer Welfare Foundation (VFWF), we are
              dedicated to uplifting the lives of farmers and their families
              across India. We understand the challenges faced by the
              agricultural sector, and we strive to bridge the gap towards a
              more prosperous and sustainable future for our farmers.
            </p>
            <p>
              As a registered non-profit organization, VFWF is proud to hold an
              80G certificate issued by the Income Tax Department of India. This
              certification allows us to accept vital Corporate Social
              Responsibility (CSR) funding from companies committed to giving
              back to society. Your CSR contribution to VFWF will directly
              support our impactful initiatives designed to empower farmers and
              their families in five key areas:
            </p>
            <p>
              By partnering with VFWF through CSR funding, your company can make
              a significant and lasting impact on the lives of farmers and their
              families in rural India. Your contribution will directly translate
              into improved education for children, better health outcomes for
              families, enhanced skills for young farmers, increased access to
              resources, and empowered women driving positive change in their
              communities. Together, we can build a more sustainable and
              prosperous future for Indian agriculture.
            </p>
            <b>
              Become a CSR partner with Venkateshwara Farmer Welfare Foundation
              today and invest in the future of our farmers!
            </b>
            <br />
            <div className="btn btn-success rounded-0 btn-lg mt-3">
              <NavLink
                to="/contact"
                className="text-white text-decoration-none"
              >
                Donate Now
              </NavLink>
            </div>
            <h2 className="mt-4">Key Focus Areas</h2> <hr />
            <div className="row mt-5">
              {data.length > 0 ? (
                data.map((item) => (
                  <div className="col-md-4 my-3" key={item.id}>
                    <div className="card" style={{ height: "38rem" }}>
                      {item.image && (
                        <Slider
                          dots={true}
                          arrows={false}
                          infinite={true}
                          speed={500}
                          slidesToShow={1}
                          slidesToScroll={1}
                          autoplay={true}
                          autoplaySpeed={3000}
                        >
                          {(() => {
                            // Flexible parsing: works with string or array
                            let images = [];
                            try {
                              if (Array.isArray(item.image)) {
                                images = item.image;
                              } else if (typeof item.image === "string") {
                                images = JSON.parse(item.image || "[]");
                              }
                            } catch (e) {
                              console.error("Image parse error:", e);
                              images = [];
                            }

                            return images.map((img, idx) => (
                              <div key={idx}>
                                <img
                                  src={img}
                                  alt={`csr-${idx}`}
                                  height={250}
                                  style={{ objectFit: "cover", width: "100%" }}
                                />
                              </div>
                            ));
                          })()}
                        </Slider>
                      )}

                      <div className="card-body">
                        <h5>{item.title}</h5>
                        <p style={{ textAlign: "justify" }}>
                          {item.description}
                        </p>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-center">No CSR records found.</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <Volunteer />
    </>
  );
}

export default CsrInitiatives;
